module.exports = __webpack_public_path__ + "img/mindshare.1b21215.png";